'use client'

import { LuneTheme, useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Text from '@mui/material/Typography'
import { FC } from 'react'

import LearnMoreTiles from '@/components/LearnMoreTiles'

const BoostingBottomLine: FC<{}> = () => {
    const { xsScreen, smScreen, mdScreen } = useDevice()

    const { spacing } = LuneTheme
    return (
        <Box>
            <Stack
                sx={{
                    mb: {
                        xs: `${spacing(7)} !important`,
                        sm: `${spacing(7)} !important`,
                        md: `${spacing(9)} !important`,
                        lg: `${spacing(9)} !important`,
                        xl: `${spacing(9)} !important`,
                    },
                }}
                spacing={5}
            >
                <Text
                    variant={mdScreen ? 'h5' : 'h4'}
                    sx={{
                        textAlign: smScreen ? 'left' : 'center',
                    }}
                >
                    Result: Boosting the bottom line
                </Text>
                <Text
                    variant={mdScreen ? 'body2' : 'body1'}
                    sx={{
                        textAlign: smScreen ? 'left' : 'center',
                    }}
                >
                    {`Driving climate action alone was a win for Payhawk, but emission reporting was also a commercial opportunity. Now, more than 200 of Payhawk's customers are leveraging Lune’s emission calculations.`}
                </Text>
            </Stack>
            <LearnMoreTiles
                sx={{
                    ...(xsScreen
                        ? {}
                        : {
                              gap: 9,
                          }),
                }}
                renderOnSx={{
                    ...(xsScreen
                        ? {}
                        : {
                              flex: '0 0 calc(33% - 72px)',
                          }),
                }}
                tiles={[
                    {
                        title: <>Driving revenue, fast</>,
                        icon: '/icons/icon-lead-innovation.png',
                        description:
                            'Taking just two weeks to implement, Payhawk snatched several quick wins. In six months, over 200 customers have adopted the new feature — leaving their competitors scrambling to catch up.',
                    },
                    {
                        title: <>Unlocking a new champion</>,
                        icon: '/icons/icon-high-quality-peace-1.png',
                        description: `Payhawk Green appeals to a new buyer persona: the sustainability lead. With over half of organisations boosting sustainability investments in 2024, and green hiring in the EU up 667% in the last four years, this stakeholder's influence is growing.`,
                    },
                    {
                        title: 'Building brand equity',
                        icon: '/icons/icon-easy-platform.png',
                        description:
                            'Payhawk representatives are now invited to share their scope 3 knowledge at conferences worldwide. They’re not being pushed along by the green transition, they’re leading it.',
                    },
                ]}
            />
        </Box>
    )
}

export default BoostingBottomLine
